import { gameConfig } from '../../../core/configs';
import {
  gamePadResource,
  gamePadResourceNames,
} from '../../../core/gameConstants';
import { FONT_LATO_NAME, PROVIDER_NAME } from '../../../core/constats';
import { getTime } from '../../../core/helpers/getTime';
import { getTranslation, translationKeys } from '../../../core/translation/translation';
import { BaseGamePadDrawer } from './BaseGamePadDrawer';
import { mobileGameRssNames } from '../../../core/mobileResourceNames';
import { soundService } from '../../../services/helperService/PixiSoundService';
import { autoSpinHelper } from '../../../services/helperService/AutoSpinHelper';
import { gamePadLocaleState } from '../state';
import { spinButtonHelper } from '../../../services/helperService/SpinButtonHelper';
import { debounce } from '../../../core/helpers/debounce';
import { gamePadHelper } from '../../../services/helperService/GamePadHelper';
import { balanceLastWinDrawer } from '../../balanceLastWin/BalanceLastWinDrawer';
import {
  AUTO_SPIN_BUTTON_STATE,
  AUTO_SPIN_COUNT,
  AUTO_SPIN_COUNTS,
  AUTO_SPIN_INDEX,
  BET_AMOUNT_CHANGE_STATE,
  BONUS_COST_AMOUNT,
  BONUS_RESPONSE_TOTAL_AMOUNT,
  SPIN_AMOUNT,
  SPIN_AMOUNT_ACTIVE,
  SPIN_COUNT_CHANGE_STATE,
} from '../../../stateManagment/gameState';
import { popupHelper } from '../../../services/helperService/PopupHelper';
import { delay } from '../../../core/helpers/delay';
import { animationDrawer } from '../../../core/AnimationDrawer';
import { amountFormatter } from '../../../core/helpers/amountFormatter';
import { partnerService } from '../../../services/helperService/PartnerService';
import { bigWinService } from '../../../services/helperService/BigWinService';
import {gameDrawer} from "../../../game/GameDrawer";

export class GamePadDesktopDrawer extends BaseGamePadDrawer {
  constructor() {
    super();
    this.container = this.createContainer();
    this.loader = this.createLoader();
  }

  async loadResource() {
    if (!this.resources) {
      const { res } = await super.loadResource(gamePadResource, this.loader);
      this.resources = res;
    }
    return this.resources;
  }

  setFooter() {
    const footerContainer = this.createContainer();
    const rect = this.createGraphics()
      .beginFill(0x000000)
      .drawRect(
        0,
        0,
        gameConfig.width,
        30,
      );
    const providerText = new this.PIXI.Text(`Powered by ${PROVIDER_NAME}`, {
      fontSize: 14,
      fill: 0xe3c632,
    });
    const timeText = new this.PIXI.Text(getTime(), {
      fontSize: 14,
      fill: 0xFFFFFF,
    });
    rect.alpha = .8;
    this.ticker = setInterval(() => {
      timeText.text = getTime();
    }, 1000);
    this.setPosition(footerContainer, { y: 100 });
    this.setPosition(providerText, { x: 25, y: 8 });
    this.setPosition(timeText, { x: 1860, y: 8 });
    footerContainer.addChild(
      rect,
      providerText,
      timeText,
    );
    this.container.addChild(footerContainer);
  }

  setGamePadRect() {
    const rect = this.createGraphics()
      .beginFill(0x000000)
      .drawRect(
        0,
        0,
        gameConfig.width,
        100,
      );
    rect.alpha = .4;
    this.setPosition(rect, { y: 0 });
    this.container.addChild(rect);
  }

  setSpinButton({ onClick = () => null, checkActive } = {}) {
    const spinButton = this.getSpinButton({
      name: mobileGameRssNames.spinIcon,
      scale: 1.2,
      w: 180,
      h: 180,
      onClick: (arg) => {
        soundService.playSpin();
        if (checkActive()) {
          onClick(arg);
          autoSpinHelper.autoSpinFlag = gamePadLocaleState.autoSpinButtonActive.getValue();
          this.resetOpenedState();
        }
      },
    });
    this.setPosition(spinButton, { x: 1350, y: -20 });
    this.addSubscriber(autoSpinHelper.subscribeAutoSpinState((isAutoSpin) => {
      spinButton.visible = !isAutoSpin;
    }, true));
    this.container.addChild(spinButton);
  }

  resetOpenedState() {
    gamePadLocaleState.betButtonActive.next(false);
    gamePadLocaleState.autoSpinButtonActive.next(false);
  }

  setAutoSpinButton({ onClick = () => null, checkActive = () => true } = {}) {
    const button = this.getAutoSpinButton({
      name: mobileGameRssNames.autoSpinIcon,
      infinity: mobileGameRssNames.infinityIconDark,
      countObserver: AUTO_SPIN_COUNT,
      scale: 1.2,
      w: 180,
      h: 180,
      onClick: (arg) => {
        soundService.playSpin();
        if (checkActive()) {
          onClick(arg);
          this.resetOpenedState();
        }
      },
    });
    this.addSubscriber(popupHelper.subscribeBuyBonusPopup((isOpen) => {
      if (isOpen && autoSpinHelper.isAutoSpin) {
        autoSpinHelper.pause();
      }
      if (!isOpen && autoSpinHelper.isAutoSpin && autoSpinHelper.spinCount) {
        autoSpinHelper.resume();
        delay(() => {
          this._autoSpinClick();
        }, 1000);
      }
    }));

    this.setPosition(button, { x: 1350, y: -20 });
    this.addSubscriber(autoSpinHelper.subscribeAutoSpinState((isAutoSpin) => {
      button.visible = isAutoSpin;
    }, true));
    this.container.addChild(button);
  }

  setLastWinAndBalance(isBonus = false) {
    const container = this.createContainer('LastWinAndBalance');
    const content = balanceLastWinDrawer.getContent({ isBonus, sizes: { w: 200 } });
    this.setPosition(container, { x: 300, y: 15 });
    container.addChild(content);
    this.container.addChild(container);
  }

  __setBetAmountToggle({ texture }) {
    this.addSubscriber(SPIN_AMOUNT.subscribe(amounts => {
      const index = SPIN_AMOUNT_ACTIVE.getValue();
      texture.text = amounts[index];
    }, true));
    this.addSubscriber(SPIN_AMOUNT_ACTIVE.subscribe(index => {
      texture.text = SPIN_AMOUNT.getValue()[index];
    }, true));
  }

  __setSpinCountToggle({ texture, infinityIcon }) {
    infinityIcon.alpha = 0;

    this.addSubscriber(AUTO_SPIN_COUNTS.subscribe(amounts => {
      const index = AUTO_SPIN_INDEX.getValue();
      if (amounts[index] === Infinity) {
        texture.alpha = 0;
        infinityIcon.alpha = 1;
      } else {
        texture.alpha = 1;
        infinityIcon.alpha = 0;
      }
      texture.text = amounts[index];
    }, true));

    this.addSubscriber(AUTO_SPIN_INDEX.subscribe(index => {
      const value = AUTO_SPIN_COUNTS.getValue()[index];
      if (value === Infinity) {
        texture.alpha = 0;
        infinityIcon.alpha = 1;
      } else {
        texture.alpha = 1;
        infinityIcon.alpha = 0;
      }
      texture.text = AUTO_SPIN_COUNTS.getValue()[index];
    }, true));
  }

  setBetAmount() {
    const betAmountContainer = this.createContainer('BetAmount');
    const amountContent = this.createSprite(this.resources[gamePadResourceNames.autoSpinTypeBetAmountContent]);
    const betAmountPlus = this.createSprite(this.resources[gamePadResourceNames.betAmountPlus]);
    const betAmountMinus = this.createSprite(this.resources[gamePadResourceNames.betAmountMinus]);

    const amount = new this.PIXI.Text('', {
      fill: 0xFFFFFF,
      fontFamily: FONT_LATO_NAME,
      fontSize: 25,
      fontWeight: 900,
    });

    amountContent.anchor.set(.5);
    betAmountPlus.anchor.set(.5);
    betAmountMinus.anchor.set(.5);
    amount.anchor.set(.5);
    amountContent.scale.set(1);

    this.setPosition(betAmountMinus, { x: -amountContent.width / 2 - betAmountMinus.width / 2 - 10 });
    this.setPosition(betAmountPlus, { x: amountContent.width / 2 + betAmountMinus.width / 2 + 10 });
    this.setPosition(betAmountContainer, { x: gameConfig.width / 2, y: 50 });

    this.setupButtonMode(betAmountMinus);
    this.setupButtonMode(betAmountPlus);

    this.addSubscriber(BET_AMOUNT_CHANGE_STATE.subscribe(val => {
      if (val) {
        betAmountContainer.alpha = 1;
      } else {
        betAmountContainer.alpha = .5;
      }
    }, true));
    this.registerClick(betAmountMinus, () => {
      this.resetOpenedState();
      if (BET_AMOUNT_CHANGE_STATE.getValue()) {
        soundService.playBetAmountChange();
        gamePadHelper.decrementBetAmount();
      }
    });
    this.registerClick(betAmountPlus, () => {
      if (BET_AMOUNT_CHANGE_STATE.getValue()) {
        this.resetOpenedState();
        soundService.playBetAmountChange();
        gamePadHelper.incrementBetAmount();
      }
    });
    this.addSubscriber(SPIN_AMOUNT_ACTIVE.subscribe(index => {
      const [disabled, active] = [.5, 1];
      const min = 0;
      const max = SPIN_AMOUNT.getValue().length - 1;
      betAmountMinus.alpha = active;
      betAmountPlus.alpha = active;

      if (index === min) {
        betAmountMinus.alpha = disabled;
      }

      if (index === max) {
        betAmountPlus.alpha = disabled;
      }
    }, true));
    this.__setBetAmountToggle({ texture: amount });
    betAmountContainer.addChild(
      amountContent,
      betAmountPlus,
      betAmountMinus,
      amount,
    );
    this.container.addChild(betAmountContainer);
  }

  setAutoSpin() {
    const autoSpinController = this.createContainer('autoSpinController');
    const autoSpinContainer = this.createContainer('autoSpinContainer');
    const countContainer = this.createContainer('countContainer');
    const content = this.createSprite(this.resources[gamePadResourceNames.autoSpinTypeBetAmountContent]);
    const autoSpinContainerBg = this.createSprite(this.resources[gamePadResourceNames.autoSpinTypeBetAmountContent]);
    const activeBorder = this.createSprite(this.resources[gamePadResourceNames.hoverAutoSpin]);
    const left = this.createSprite(this.resources[gamePadResourceNames.leftArrowIcon]);
    const right = this.createSprite(this.resources[gamePadResourceNames.rightArrowIcon]);

    const autoSpinTitle = new this.PIXI.Text(getTranslation(translationKeys.AUTOSPIN), {
      fill: 0xFFFFFF,
      fontFamily: FONT_LATO_NAME,
      fontSize: 25,
      fontWeight: 900,
    });


    const playTitle = new this.PIXI.Text(getTranslation(translationKeys.PLAY), {
      fill: 0xFFFFFF,
      fontFamily: FONT_LATO_NAME,
      fontSize: 25,
      fontWeight: 900,
    });
    playTitle.visible = false;
    const count = new this.PIXI.Text('500', {
      fill: 0xFFFFFF,
      fontFamily: FONT_LATO_NAME,
      fontSize: 25,
      fontWeight: 900,
    });
    const infinityIcon = this.createSprite(this.resources[mobileGameRssNames.infinityIcon]);
    countContainer.addChild(
      count,
      infinityIcon,
    );
    const leftCircle = this.createGraphics()
      .beginFill(0x636363)
      .drawCircle(
        0,
        0,
        22,
      ).endFill();
    const rightCircle = this.createGraphics()
      .beginFill(0x636363)
      .drawCircle(
        0,
        0,
        22,
      ).endFill();

    count.anchor.set(.5);
    content.anchor.set(.5);
    autoSpinContainerBg.anchor.set(.5);
    activeBorder.anchor.set(.5);
    autoSpinTitle.anchor.set(.5);
    playTitle.anchor.set(.5);
    infinityIcon.anchor.set(.5);
    infinityIcon.scale.set(1);

    content.scale.set(1);
    autoSpinContainerBg.scale.set(1);

    left.anchor.set(.5);
    right.anchor.set(.5);

    const positionX = autoSpinContainerBg.width / 2 - 30;
    this.setPosition(left, { x: -positionX });
    this.setPosition(right, { x: positionX });
    this.setPosition(leftCircle, { x: -positionX });
    this.setPosition(rightCircle, { x: positionX });
    this.setupButtonMode(leftCircle);
    this.setupButtonMode(rightCircle);
    this.__setSpinCountToggle({ texture: count, infinityIcon });

    this.registerClick(leftCircle, (event) => {
      event.stopPropagation();
      soundService.playSpinCountChange();
      gamePadHelper.decrementAutoSpin();
    });

    this.registerClick(rightCircle, (event) => {
      event.stopPropagation();
      soundService.playSpinCountChange();
      gamePadHelper.incrementAutoSpin();
    });

    autoSpinContainer.addChild(
      autoSpinContainerBg,
      leftCircle,
      rightCircle,
      left,
      right,
      countContainer,
    );

    autoSpinController.addChild(
      content,
      activeBorder,
      autoSpinTitle,
      playTitle,
      autoSpinContainer,
    );

    this.setupButtonMode(content);
    this.addSubscriber(AUTO_SPIN_BUTTON_STATE.subscribe(active => {
      if (active) {
        playTitle.alpha = 1;
        activeBorder.alpha = 1;
      } else {
        playTitle.alpha = .5;
        activeBorder.alpha = .5;
      }
    }, true))
    this.registerClick(content, (event) => {
      event.stopPropagation();
      if (SPIN_COUNT_CHANGE_STATE.getValue()) {
        soundService.playSingleClick();
        const state = gamePadLocaleState.autoSpinButtonActive.getValue();
        playTitle.visible = !state;
        autoSpinTitle.visible = state;
        if (state) {
          this.handleAutoSpinClick();
        }
        gamePadLocaleState.autoSpinButtonActive.next(!state);

        // if (state && !WHEEL_ROTATION_STATE.getValue()) {
        //   this.handleAutoSpinClick();
        //   playTitle.visible = false;
        //   autoSpinTitle.visible = false;
        //   gamePadLocaleState.autoSpinButtonActive.next(false);
        // }
        // if (!state) {
        //   playTitle.visible = true;
        //   autoSpinTitle.visible = false;
        //   gamePadLocaleState.autoSpinButtonActive.next(true);
        // }
      }
    });

    this.addSubscriber(gamePadLocaleState.autoSpinButtonActive.subscribe(isOpen => {
      autoSpinContainer.visible = isOpen;
      activeBorder.visible = isOpen;
      playTitle.visible = isOpen;
      autoSpinTitle.visible = !isOpen;
    }, true));

    this.addSubscriber(SPIN_COUNT_CHANGE_STATE.subscribe(val => {
      if (val) {
        autoSpinController.alpha = 1;
      } else {
        autoSpinController.alpha = .5;
      }
    }, true));

    this.addSubscriber(AUTO_SPIN_INDEX.subscribe(index => {
      const [disabled, active] = [0, 1];
      const min = 0;
      const max = AUTO_SPIN_COUNTS.getValue().length - 1;
      leftCircle.alpha = active;
      rightCircle.alpha = active;

      if (index === min) {
        leftCircle.alpha = disabled;
      }

      if (index === max) {
        rightCircle.alpha = disabled;
      }
    }, true));

    this.setPosition(autoSpinContainer, { x: 0, y: -autoSpinContainerBg.height - 10 });
    this.setPosition(autoSpinController, { x: gameConfig.width / 2 + 650, y: 50 });
    this.container.addChild(
      autoSpinController,
    );
  }

  destroy() {
    clearInterval(this.ticker);
    super.destroy();
  }

  setContainerPosition() {
    this.setPosition(this.container, gameConfig.gamePadPosition);
  }

  setBonusPressToStart({ onClick }) {
    const textContainer = this.createContainer();
    const title = new this.PIXI.Text(`${getTranslation(translationKeys.pressToStart)}`, {
      fill: [0xfefefd, 0x9b7853],
      fontFamily: FONT_LATO_NAME,
      stroke: '#dec195',
      strokeThickness: 1,
      fontSize: 45,
      align: 'center',
    });

    const style = {
      fill: [0xfefefd, 0x9b7853],
      fontFamily: FONT_LATO_NAME,
      stroke: '#dec195',
      strokeThickness: 1,
      fontSize: 45,
      align: 'center',
    };

    const totalWinAmount = new this.PIXI.Text('', { ...style });
    title.interactive = true;
    title.buttonMode = true;
    title.on('pointerdown', () => {
      soundService.playSpin();
      if (spinButtonHelper.active) {
        onClick();
      }
    });
    title.anchor.set(.5);
    totalWinAmount.anchor.set(.5);
    totalWinAmount.alpha = 0;
    this.addSubscriber(BONUS_RESPONSE_TOTAL_AMOUNT.subscribe((value) => {
      const amount = value || 0;
      animationDrawer.blinking(totalWinAmount, .5, [1.1, .9, 1]);
      const text = `Win: ${amountFormatter.format(amount)} ${partnerService.displayCurrency}`;
      if (text.length > 19) {
        totalWinAmount.style = {
          ...style,
          fontSize: 40,
        };
      } else {
        totalWinAmount.style = {
          ...style,
          fontSize: 45,
        };
      }
      totalWinAmount.text = text;

    }, true));

    this.setPosition(textContainer, { x: gameConfig.width / 2, y: -100 });


    this.totalWinAmount = totalWinAmount;
    this.title = title;
    textContainer.addChild(
      totalWinAmount,
    );
    this.container.addChild(
      textContainer,
    );
  }

  setBonusCost() {
    const style = {
      fill: [0xfefefd, 0x9b7853],
      fontFamily: FONT_LATO_NAME,
      stroke: '#dec195',
      strokeThickness: 1,
      fontSize: 45,
      align: 'center',
    };

    const text = new this.PIXI.Text('', {
      ...style,
    });

    text.anchor.set(.5);
    this.setPosition(text, { x: gameConfig.width / 2, y: 50 });
    this.addSubscriber(BONUS_COST_AMOUNT.subscribe(value => {
      text.text = `${getTranslation(translationKeys.BET_AMOUNT)} ${amountFormatter.format(value)} ${partnerService.displayCurrency}`;
    }, true));
    this.container.addChild(text);
  }

  addBonusPressToStartLayer({ root }) {
    const rect = this.createGraphics()
      .beginFill(0x00000)
      .drawRect(0, 0, gameConfig.width, gameConfig.height)
      .endFill();
    rect.alpha = 0;
    this.setupButtonMode(rect);
    this.registerClick(rect, event => {
      event.stopPropagation();
      if (spinButtonHelper.active) {
        spinButtonHelper.disable();
        this.totalWinAmount.alpha = 1;
        this.title.alpha = 0;
        this._bonusSpinClick();
      }
    });
    root.addChild(rect);
  }

  handleBonusClick() {
    if (spinButtonHelper.active) {
      spinButtonHelper.disable();
      this.totalWinAmount.alpha = 1;
      this.title.alpha = 0;
      super.handleBonusClick();
    }
  }

  async onLoad() {
    return this.loadResource();
  }

  async executeMainScene() {
    await this.loadResource();
    bigWinService.setContinueCallBack(() => {
      this._autoSpinClick();
    });
    bigWinService.setResumeCallBack(() => autoSpinHelper.resume());
    this.setContainerPosition();
    this.setFooter();
    this.setGamePadRect();
    this.setSpinButton({
      checkActive: () => spinButtonHelper.active,
      onClick: this.handleSpinButtonClick(),
    });
    this.setAutoSpinButton({
      onClick: this.handleAutoSpinButtonClick(),
    });
    this.setLastWinAndBalance();
    this.setBetAmount();
    this.setAutoSpin();
  }

  async executePreBonusScene() {
    await this.loadResource();
    this.setContainerPosition();
    this.setFooter();
    this.setGamePadRect();
    this.setLastWinAndBalance();
    // this.setSpinButton({
    //   checkActive: () => spinButtonHelper.active,
    //   onClick: this.handlePreBonusSpinButtonClick(),
    // });
  }

  async executeBonusScene() {
    await this.loadResource();
    bigWinService.setContinueCallBack(() => this._bonusSpinClick());
    this.setContainerPosition();
    this.setFooter();
    this.setGamePadRect();
    this.setLastWinAndBalance(true);
    this.setBonusPressToStart({
      onClick: debounce(() => {
        this._bonusSpinClick();
      }, 300, true),
    });
    this.setBonusCost();
  }
}
